export const companiesCompanyIdSecuritySettingsSecurityEventConfig =
  "/companies/:company_id/security_settings/security_event_config";
